document.addEventListener('turbo:load', function () {
  const backButton = document.querySelector('.fa-angle-double-left');

  if (backButton) {
    backButton.addEventListener('click', (event) => {
      event.preventDefault();
      history.back();
    });
  }
});
